import { ArrowLeftIcon, LogoutIcon } from '@heroicons/react/solid';
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = (props) => {
  if (props.isLoading) return null;

  if (!props.isLoggedin && !props.showPlants) {
    return (
      <button className="flex mx-auto mt-16 text-accent-500 border-2 border-accent-500 py-1 px-4 focus:outline-none hover:text-accent-600 hover:border-accent-600 rounded text-lg">
        <Link to="/admin">Admin Login</Link>
      </button>
    );
  }

  return (
    <>
      {props.isLoggedin && (
        <>
          <button
            onClick={() => props.logoutUser()}
            className="flex mx-auto text-gray-500 border-2 border-gray-500 rounded-full py-2 px-2 focus:outline-none hover:text-gray-800 hover:border-gray-800 text-lg fixed top-2 right-2"
          >
            <LogoutIcon className="h-5 w-5" />
          </button>
          {!props.showPlants && (
            <button className="flex mx-auto mt-16 text-accent-500 border-2 border-accent-500 py-1 px-4 focus:outline-none hover:text-accent-600 hover:border-accent-600 rounded text-lg">
              <Link to="/gifted">Gifted/Dead</Link>
            </button>
          )}
        </>
      )}
      {props.showPlants && (
        <button
          onClick={props.goBack}
          className="flex mx-auto text-gray-500 border-2 border-gray-500 rounded-full py-2 px-2 focus:outline-none hover:text-gray-800 hover:border-gray-800 text-lg fixed top-2 left-2"
        >
          <ArrowLeftIcon className="h-5 w-5" />
        </button>
      )}
    </>
  );
};

export default Footer;
